import { cloneDeep } from "lodash";
import ILessonPageDto from "../models/ILessonPageDto";
import { MirrorableObjects, mirrorObjectsOntoPageManifest } from "../utils/lessonPages/mirrorObjectsOntoPageManifest";

interface SyncDisplayedPageStateParams {
  lessonPages: ILessonPageDto[];
  currentAggregationOrder: number | null;
  currentlyDisplayedPageIndex: number;
  objects: MirrorableObjects;
  narrationAudios: readonly unknown[];
  audioEffects: readonly unknown[];
}

function isFreeFormBasePage(page: ILessonPageDto, pageManifest: any): boolean {
  return page.pagePlayerType === "Base" && pageManifest?.basePageType === "freeForm";
}

export function syncDisplayedPageState({
  lessonPages,
  currentAggregationOrder,
  currentlyDisplayedPageIndex,
  objects,
  narrationAudios,
  audioEffects,
}: SyncDisplayedPageStateParams): ILessonPageDto[] {
  const updatedPages = [...lessonPages];
  const objectsToMirror: MirrorableObjects = {
    ...objects,
    narrationAudios: [...narrationAudios],
    audioEffects: [...audioEffects],
  };

  if (currentAggregationOrder !== null) {
    const aggregationPage = updatedPages[currentAggregationOrder];
    const subPages = aggregationPage?.pageManifest?.Pages;
    if (!aggregationPage || !subPages?.[currentlyDisplayedPageIndex]) {
      return updatedPages;
    }

    const updatedSubPages = [...subPages];
    const currentSubPage = updatedSubPages[currentlyDisplayedPageIndex];
    const clonedSubPage = {
      ...currentSubPage,
      pageManifest: cloneDeep(currentSubPage.pageManifest),
      pageManifestIsDirty: true,
    };

    mirrorObjectsOntoPageManifest(
      clonedSubPage.pageManifest,
      objectsToMirror,
      isFreeFormBasePage(clonedSubPage, clonedSubPage.pageManifest),
    );

    updatedSubPages[currentlyDisplayedPageIndex] = clonedSubPage;
    updatedPages[currentAggregationOrder] = {
      ...aggregationPage,
      pageManifest: {
        ...aggregationPage.pageManifest,
        Pages: updatedSubPages,
      },
      pageManifestIsDirty: true,
    };

    return updatedPages;
  }

  const currentPage = updatedPages[currentlyDisplayedPageIndex];
  if (!currentPage) {
    return updatedPages;
  }

  const clonedCurrentPage = {
    ...currentPage,
    pageManifest: cloneDeep(currentPage.pageManifest),
    pageManifestIsDirty: true,
  };

  mirrorObjectsOntoPageManifest(
    clonedCurrentPage.pageManifest,
    objectsToMirror,
    isFreeFormBasePage(clonedCurrentPage, clonedCurrentPage.pageManifest),
  );

  updatedPages[currentlyDisplayedPageIndex] = clonedCurrentPage;
  return updatedPages;
}
